// eslint-disable-next-line import/no-anonymous-default-export
export default {
  backgroundColor: '#cee4e5',
};
